import CheckHealthServer from "./CheckHealthServer";
import { AxiosInstance } from "axios";
import useOnlineStatus from "./useOnlineStatus";
import Affix from "antd/es/affix";
import Alert from "antd/es/alert";

type Props = {
	url: string;
	axiosInstance: AxiosInstance;
	intervalCheck?: number;
};

export function MainCheckHealth(props: Props) {
	const isOnline = useOnlineStatus();

	return (
		<div>
			{isOnline ? (
				<CheckHealthServer
					url={props.url}
					axiosInstance={props.axiosInstance}
					intervalCheck={props.intervalCheck}
				/>
			) : (
				<Affix offsetTop={10}>
					<Alert
						banner
						message="You are offline. Please check your internet connection."
						type="error"
						style={{ textAlign: "center", color: "red" }}
					/>
				</Affix>
			)}
		</div>
	);
}
